// extracted by mini-css-extract-plugin
export var container = "steps-module--container--6SiLm";
export var img = "steps-module--img--c-T2V";
export var item = "steps-module--item--PyFTZ";
export var step_container = "steps-module--step_container--guuu2";